import React, { Component } from 'react';
import testimonial from '../../../data/testimonial.json';
import review1 from '../../../assets/img/home/review-1.jpeg';
import review2 from '../../../assets/img/home/review-2.jpeg';
class Testimonials extends Component {
  render() {
    return (
      <div className='section section-padding'>
        <div className='container'>
          <div className='section-title-wrap section-header'>
            <h5 className='custom-primary'>Testimonials</h5>
            <h2 className='title'>What Are People Saying</h2>
          </div>
          <div className='row'>
            {/* Testimonail item start */}
            <div className='col-lg-6 col-md-12'>
              <div className='acr-testimonial'>
                <img src={review1} alt='testimonial' className='acr-testimonial-img'/>
              </div>
            </div>
            <div className='col-lg-6 col-md-12'>
              <div className='acr-testimonial'>
                <img src={review2} alt='testimonial' className='acr-testimonial-img'/>
              </div>
            </div>
            {/* Testimonail item end */}
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonials;
